export default __webpack_public_path__ + "static/media/search.d997ab338349b0ab1686182ba5b4c5ca.svg";